import { render, staticRenderFns } from "./featured-image.vue?vue&type=template&id=783464e8&scoped=true"
import script from "./featured-image.vue?vue&type=script&lang=js"
export * from "./featured-image.vue?vue&type=script&lang=js"
import style0 from "./featured-image.vue?vue&type=style&index=0&id=783464e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783464e8",
  null
  
)

export default component.exports